import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router
} from '@angular/router';
import { RcService } from '../services/rc.service';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class RcRedirectGuard implements CanActivate {
	constructor(
		private readonly rcService: RcService,
		private readonly router: Router,
		private readonly authService: AuthService
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		// Check if we're on localhost
		const isLocalhost =
			globalThis.location.hostname.includes('localhost') ||
			globalThis.location.hostname.includes('127.0.0.1');

		if (isLocalhost || globalThis.location.hostname === 'rms.katdev.com') {
			return true; // Allow access on localhost
		}

		// Get the RC from URL parameters
		const rcParam = route.params['rc'];

		// Validate RC parameter exists and is valid
		if (!rcParam || !this.rcService.isValidRc(rcParam)) {
			return true; // Let other guards handle invalid RC
		}

		// Check if we're accessing select-rc with a valid RC
		const urlPath = state.url;
		if (urlPath.includes('/select-rc')) {
			// Set the RC
			this.rcService.setRc(rcParam);
			localStorage.setItem('currentRc', rcParam);

			// Determine redirect destination based on authentication
			const redirectUrl = this.authService.isAuthenticated()
				? `/${rcParam}`
				: `/${rcParam}/auth/login`;

			// Use replaceUrl to avoid adding to browser history
			this.router.navigate([redirectUrl], { replaceUrl: true });
			return false;
		}

		return true;
	}
}
